import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import appInfo, { isStaffOrSuperUser } from "@common/appInfo";
import { setShowingAccountDetailId, showAddEditAccountModal, showTransferModal } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import {
  localStateSelector,
  makeAccountDetailSelector,
  makeAccountStyleSelector,
  makeItemsSelector
} from "./selectors";
import { type MemberWallet } from "./types";

const makeMapStateToProps = () => {
  const itemsSelector = makeItemsSelector();
  const detailSelector = makeAccountDetailSelector();
  const accountStyleSelector = makeAccountStyleSelector();
  const titleSelector = getSettingValueSelector(TargetSelector.Entity, "title");
  const columnsSelector = getSettingValueSelector(TargetSelector.Entity, "columns");
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    const accounts = itemsSelector(state, props);

    return {
      ...props,
      accounts: accounts,
      accountStyle: accountStyleSelector(state, props),
      apiInfo: apiInfoSelector(state, props),
      canAdd: !isStaffOrSuperUser(),
      columns: columnsSelector(state, props),
      currencies: localState.currencies,
      detail: detailSelector(state, props),
      isEditMode: state.isEditMode,
      refreshKey: localState.refreshKey,
      status: localState.status,
      title: titleSelector(state, props),
      userId: appInfo.user?.id ?? null
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onAddEditClick: () => dispatch(showAddEditAccountModal(getEntityRef(props))),
  onBackClick: () => dispatch(setShowingAccountDetailId({ ...getEntityRef(props), accountId: null })),
  onItemClick: (item: MemberWallet.Account) =>
    dispatch(setShowingAccountDetailId({ ...getEntityRef(props), accountId: item.accountId })),
  onTransferClick: () => dispatch(showTransferModal(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
